import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dictamen-medico',
  templateUrl: './dictamen-medico.component.html',
  styleUrls: ['./dictamen-medico.component.scss']
})
export class DictamenMedicoComponent implements OnInit {
  public form: FormGroup;
  public casoId: string | null = null;

  constructor(private fb: FormBuilder, private route: ActivatedRoute) {
    this.form = this.fb.group({
      fecha: [new Date().toISOString().slice(0,10), Validators.required],
      medico: ['', Validators.required],
      decision: ['recuperable', Validators.required],
      criterios: ['', Validators.required],
      recomendaciones: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    // Suscribirse a parámetros para precargar un caso si se navega con /dictamen-medico/:id
    this.route.paramMap.subscribe((pm) => {
      const id = pm.get('id');
      this.casoId = id;
      if(id ==='EXP-2025-0001'){
        
      }
      if (id) {
        // Datos demo para prefilling; reemplazar por llamada a servicio cuando exista
        this.form.patchValue({
          fecha: new Date().toISOString().slice(0,10),
          medico: '',
          decision: 'recuperable',
          criterios: `Criterios iniciales para el caso ${id}`,
          recomendaciones: `Recomendaciones iniciales para el caso ${id}`,
        });
      }
    });
  }

  ngAfterViewInit(): void {
    // Leer parámetro id si se llamó con /dictamen-medico/:id
    // no usamos snapshot en caso de navegación interna
  }

  /** Lee parámetros de ruta y precarga datos demo si se proporciona un id */
  ngAfterContentInit(): void {
    // placeholder to satisfy lifecycle ordering in some setups
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    // Aquí iría la llamada al servicio que persiste el dictamen
    console.log('Dictamen médico guardado (demo):', this.form.value);
    alert('Dictamen guardado (demo)');

    // reset minimal
    this.onReset();
  }

  /** Reset the form to sensible defaults. Kept as a method because templates cannot use `new` or complex expressions. */
  onReset(): void {
    this.form.reset({ decision: 'recuperable', fecha: new Date().toISOString().slice(0,10) });
  }
}
